import React, { Component } from 'react';
import { TableRowInput } from '../../component/anulacion/children/tr-input';
export default class Modal extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        // validate if the props changes
        if (prevProps.show != this.props.show) {
            $(this.refs.modal).modal(this.props.show ? 'show' : 'hide');
        }
    }

    render() {
        const { onCloseModal, onChangeArchivo, onChangeInputUploadFile  } = this.props;
        return (
            <div className="modal" tabIndex="-1" role="dialog" ref="modal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Carga Masiva de Cancelaciones</h3>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCloseModal}>
                                <span aria-hidden="false">&times;</span>
                            </button>
                        </div> 
                        <div className="modal-body">
                            <h5 className="modal-title">Columna &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Formato</h5>
                            <div className="table-responsive">
                                <table className="table table-sm">
                                    <tbody>
                                        <TableRowInput title="UUID"
                                            type="text"
                                            name="UUID"
                                            value="Caracteres"
                                        />
                                        <TableRowInput title="Motivo"
                                            type="text"
                                            name="Motivo"
                                            value="Caracteres (01|02|03)"
                                        />
                                        <TableRowInput title="Sustituto"
                                            type="text"
                                            name="Sustituto"
                                            value="Caracteres"
                                        />
                                    </tbody>
                                </table>
                            </div>
                            <input type="file" className='btn btn-outline-primary' onChange={onChangeArchivo} /> 
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" aria-label="OK" onClick={onChangeInputUploadFile}>
                                <i className=""></i> OK
                            </button>
                            <button type="button" className="btn btn-danger" aria-label="Close" onClick={onCloseModal}>
                                <i className=""></i> Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./Public/src/js/util/modal/ImportadorCancelacion.jsx